import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementShiftListResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaShiftName } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useRotaShiftNameAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    // dispatch(
    //   setLoading({
    //     key: "isOrgServicesInProgress",
    //     status: true,
    //   })
    // );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ROTA_APIS?.ROTA_SHIFT_NAME_API?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IRotaManagementShiftListResponse>) => {
          if (res.data.status === true) {
            dispatch(setRotaShiftName({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isOrgServicesInProgress",
                status: false,
              }),
            );
          } else {
            //
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            toast.error("Error while fetching  shift name");
          }
          if (e.status === 400) {
            toast("Shift records not found");
          }
          if (e.response.status === 500) {
            toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
